import React from 'react';
import TodoItem from './TodoItem';
import PropTypes from 'prop-types';
import './Todos.css';

class Todos extends React.Component{
    render(){
        return(
            <div className="conteneur_todos">
                {this.props.todos.map((todo)=>(
                    <TodoItem key={todo.id} todo={todo} changeCompletedState={this.props.changeCompletedState} delTodo={this.props.delTodo}/>
                ))}
            </div>
        ); 
    }
}

// PropTypes:
Todos.propTypes = {
    todos: PropTypes.array.isRequired
};

export default Todos;